import React from 'react';
import cn from 'bem-cn-lite';

import {useDispatch, useSelector} from '../../store/redux-hooks';
import {type PageInfo, selectPagesOrderedByUser} from '../../store/selectors/slideoutMenu';
import {Icon, List} from '@gravity-ui/uikit';
import {PAGE_ICONS_BY_ID} from '../../constants/slideoutMenu';
import {setPagesItemPosition, togglePinnedPage} from '../../store/actions/slideoutMenu';

import pinIcon from '../../assets/img/svg/pin.svg';
import pinSolidIcon from '../../assets/img/svg/pin-solid.svg';

import './PagesEditorPanel.scss';

const block = cn('pages-editor-panel');

export function PagesEditorPanel() {
    const pages = useSelector(selectPagesOrderedByUser);

    const dispatch = useDispatch();

    const handleSort = React.useCallback(
        (data: {oldIndex: number; newIndex: number}) => {
            dispatch(setPagesItemPosition(data));
        },
        [dispatch, pages],
    );

    const handleClick = React.useCallback(
        (id: string) => {
            dispatch(togglePinnedPage(id));
        },
        [dispatch],
    );

    return (
        <List
            className={block()}
            itemClassName={block('list-item-container')}
            filterable={false}
            sortable={true}
            sortHandleAlign={'right'}
            items={pages}
            renderItem={(item) => <PagesEditorListItem {...item} onClick={handleClick} />}
            itemHeight={40}
            onSortEnd={handleSort}
        />
    );
}

function PagesEditorListItem(props: PageInfo & {pinned?: boolean; onClick: (id: string) => void}) {
    const {id, name, pinned, onClick} = props;

    const handleClick = React.useCallback(() => {
        onClick(id);
    }, [onClick, id]);

    return (
        <div className={block('list-item')}>
            <Icon className={block('icon')} data={PAGE_ICONS_BY_ID[id]} />
            <span className={block('name')}>{name}</span>
            <div className={block('pin-icon', {pinned})} onClick={handleClick}>
                <Icon data={pinned ? pinSolidIcon : pinIcon} />
            </div>
        </div>
    );
}
